import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PanelAdminService } from 'src/app/services/panel-admin.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  itemsBreadCrumb: any[] = [];

  constructor(
    private panelService: PanelAdminService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.getBreadCrumb();
    this.router.events
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.getBreadCrumb();
        }
      });
  }

  getBreadCrumb() {
    const currentUrl = this.router.url || '';

    if (this.isEventDetailRoute(currentUrl)) {
      this.buildEventDetailBreadcrumb(currentUrl);
      return;
    }

    this.itemsBreadCrumb = [];
    let urlTree = this.router.parseUrl(currentUrl);
    const urlWithoutParams = urlTree.root.children['primary'].segments.map(it => it.path);
    urlWithoutParams.forEach((element: any) => {
      if (element === 'business' && currentUrl.includes('/business/help')) return;
      let el = this.panelService.getBreadcrumbsPage(element);
      if (el.name !== '') {
        this.itemsBreadCrumb.push(el);
        if (el.extra !== undefined && el.extra.length > 0) {
          this.itemsBreadCrumb.push(el.extra[0]);
        }
      }
    });
  }

  goPage(url: any, params: any) {
    if (url === '') return;
    if (params) {
      this.router.navigate([url], { queryParams: { [params.name]: params.value } });
      return;
    }
    this.router.navigate([url]);
  }

  private isEventDetailRoute(url: string): boolean {
    const cleanUrl = (url || '').split('?')[0];
    return (
      cleanUrl.includes('/panel-control/events/detail/') ||
      cleanUrl.includes('/panel-control/events/draft/detail/')
    );
  }

  private buildEventDetailBreadcrumb(url: string) {
    const cleanUrl = (url || '').split('?')[0];
    const optionName = this.getEventOptionNameFromUrl(cleanUrl);

    this.itemsBreadCrumb = [
      {
        name: 'Eventos',
        url: '/panel-control/events',
        params: {},
      },
      {
        name: optionName,
        url: '',
        params: {},
      },
    ];
  }

  private getEventOptionNameFromUrl(url: string): string {
    const cleanUrl = (url || '').split('?')[0];
    const mapByRoute: Array<{ key: string; name: string }> = [
      { key: '/info-event/', name: 'Información del evento' },
      { key: '/sessions-event/', name: 'Sesiones' },
      { key: '/ticket-event/', name: 'Entradas' },
      { key: '/discount-event/', name: 'Descuentos / Abonos' },
      { key: '/map-event/', name: 'Mapa de butacas' },
      { key: '/sale-config-event/', name: 'Configuración de venta' },
      { key: '/order-event/', name: 'Pedidos del evento' },
      { key: '/report-event/', name: 'Informes del evento' },
      { key: '/mailing-event/', name: 'Envío de comunicaciones' },
      { key: '/comment-event/', name: 'Gestión de comentarios' },
    ];

    return (
      mapByRoute.find((config) => cleanUrl.includes(config.key))?.name ||
      'Información del evento'
    );
  }

}
